import { render, staticRenderFns } from "./PurchasesInvoiceViewLogs.vue?vue&type=template&id=f85efb46"
import script from "./PurchasesInvoiceViewLogs.vue?vue&type=script&lang=js"
export * from "./PurchasesInvoiceViewLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports